import React from 'react'
import Navbar from '../defaultComponents/Navbar'
import Footer from '../defaultComponents/Footer'

import styled from 'styled-components'

import { useNavigate, useParams } from 'react-router-dom'
import AlllocationShifts from './AlllocationShifts'
import AllocationEmployees from './AllocationEmployees'
import AllocationDetails from './AllocationDetails'

const PageWrapper = styled.div`
  font-family: Inter;
  color: #333333;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;
  padding-left: 2vw;
`

const JobNavBanner = styled.div`
  display: flex;
  justify-content: center;
`

const JobNavBox = styled.div`
  width: 90vw;
  padding-left: 2vw;
  
  display: flex;

  gap: 20px;

  border-bottom: 1px solid black;
  padding-bottom: 10px;
`

const JobNavItem = styled.div`
  cursor: pointer;

  font-weight: bold;
`

const InfoBanner = styled.div`
  display: flex;
  justify-content: center;

  padding-top: 20px;
`

export default function AllocationsJob() {

  const navigate = useNavigate();

  const [displayInfo, setDisplayInfo] = React.useState("SHIFTS")
  const {JobId} = useParams()

  const [job, setJob] = React.useState([])
  const getJobInfo = async () => {
    try {
      const res = await fetch(`/api/allocations/jobs/${JobId}`);

      const data = await res.json();

      setJob(data[0]);
    } catch (error) {
      console.error("Error:", error)
    }
  }

  React.useEffect(()=>{
    getJobInfo()
  },[])

  return (
    <>
      <Navbar pageType="Dashboard"/>
      <PageWrapper>
        <TitleBanner>
          <TitleBox>{job.job_name} - {job.job_location}</TitleBox>
        </TitleBanner>

        <JobNavBanner>
          <JobNavBox>
            <JobNavItem onClick={()=>setDisplayInfo("DETAILS")}>Job Details</JobNavItem>
            <JobNavItem onClick={()=>setDisplayInfo("SHIFTS")}>Shifts</JobNavItem>
            <JobNavItem onClick={()=>setDisplayInfo("EMPLOYEES")}>Employees</JobNavItem>
          </JobNavBox>
        </JobNavBanner>

        <InfoBanner>
          {displayInfo === "SHIFTS" && <AlllocationShifts/>}
          {displayInfo === "EMPLOYEES" && <AllocationEmployees/>}
          {displayInfo === "DETAILS" && <AllocationDetails/>}
        </InfoBanner>
        <Footer />
      </PageWrapper>
    </>
  )
}